import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (type, meta) => {
  try {
    axios.post(`${API}/track`, { type, meta: meta || null }).catch(() => {});
  } catch (e) {
    /* fire and forget */
  }
};
